<template>
  <div class="container contract-item" >
    <table style="width:100%;">
      <tr>
        <td>{{ $t('menu.itemName') }}</td>
        <td>
          <select class="normalInput normalSelect" ref="contract_select_box" @change="changed"> 
            <option v-for="(item, index) in itemList" :value="item.NAME.trim()" v-bind:key="index" >{{item.NAME.trim()}}</option>
          </select>
        </td>
        <td>주문수량</td>
        <td><input type="number" :value="amount" class="normalInput normalSelect" /></td>
      </tr>
      <tr>
        <td>{{ $t('menu.name') }}</td>
        <td><input type="text" :value="orderName" class="normalInput normalSelect" /></td>
        <td>{{ $t('menu.phoneNumber') }}</td>
        <td><input type="number" :value="phone" class="normalInput normalSelect" /></td>
      </tr>
      <tr>
        <td>{{ $t('menu.clearance') }}</td>
        <td><input type="text" :value="clearance" class="normalInput normalSelect" /></td>
        <td>{{ $t('menu.zip') }}</td>
        <td><input type="text" :value="zipCode" class="normalInput normalSelect" /></td>
      </tr>
      <tr>
        <td v-html="address1Html"></td>
        <td><input type="text" :value="addrRoad " class="normalInput normalSelect" /></td>
        <td>{{ $t('menu.address2') }}</td>
        <td><input type="text" :value="addrDetail" class="normalInput normalSelect" /></td>
      </tr>
      <tr>
        <td>{{ $t('menu.brand') }}</td>
        <td><input type="text" :value="this.itemList[this.selectedIdx].BRAND" class="normalInput normalSelect" ref="contract_brand" disabled /></td>
        <td>{{ $t('menu.country') }}</td>
        <td><input type="text" :value="this.itemList[this.selectedIdx].COUNTRY" class="normalInput normalSelect" ref="contract_country" disabled /></td>
      </tr>
      <tr>
        <td>{{ $t('menu.fPrice') }}</td>
        <td><input type="text" :value="this.itemList[this.selectedIdx].ORIGIN_PRICE" class="normalInput normalSelect" ref="contract_fprice" disabled /></td>
        <td>{{ $t('menu.sPrice') }}</td>
        <td><input type="text" :value="this.itemList[this.selectedIdx].SELL_PRICE" class="normalInput normalSelect" ref="contract_sprice" disabled /></td>
      </tr>
      <tr>
        <td style="border-left:0px;vertical-align: middle;">{{$t('menu.url')}}</td>
        <td colspan="3" style="border-right:0px; height:30px;vertical-align: middle;"><input type="text" :value="this.itemList[this.selectedIdx].URL" class="normalInput normalSelect" ref="contract_url" disabled /></td>
      </tr>
      <tr>
        <td style="border-left:0px;vertical-align: middle;">{{ $t('menu.pictureUrl') }}</td>
        <td colspan="3" style="border-right:0px; height:30px;vertical-align: middle;"><input type="text" :value="this.itemList[this.selectedIdx].IMG_URL" class="normalInput normalSelect" disabled /></td>
      </tr>
      <tr>
        <td style="border-left:0px;vertical-align: middle;">{{ $t('menu.etc') }}</td>
        <td colspan="3" style="border-right:0px; height:30px;vertical-align: middle;"><input type="text" :value="content" class="normalInput normalSelect" /></td>
      </tr>
    </table>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  props: {
    itemName: String,
    amount: Number,
    orderName: String,
    phone: String,
    clearance: String,
    zipCode: String,
    addrRoad: String,
    addrDetail: String,
    content: String,
    itemList: ref([])
  },
  mounted() {
    this.itemList.forEach((item, index) => {
      if (item.NAME.trim() === this.itemName) {
        this.$refs.contract_select_box.selectedIndex = index
        this.selectedIdx = index
        return
      }
    })
  },
  data() { 
    return { 
      selectedIdx: 0
    } 
  },
  methods: {
    changed() {
      this.itemList.forEach((item) => {
        const selectedItemName = this.$refs.contract_select_box.value
        if (item.NAME.trim() === selectedItemName) {
          this.$refs.contract_brand.value = item.BRAND
          this.$refs.contract_country.value = item.COUNTRY
          this.$refs.contract_fprice.value = item.ORIGIN_PRICE
          this.$refs.contract_sprice.value = item.SELL_PRICE
          this.$refs.contract_url.value = item.URL
        }
      })
    }
  }
}
</script>

<style scoped>
.contract-item > table > tr > td:nth-child(odd) {
  font-weight: bold;
  min-width:100px;
  text-align:center;
  height:40px;
}
</style>
